export default __webpack_public_path__ + "static/TomaszBajarbaatar-f9ddadff3664620101464cd7d4a5f578.png";